import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { NewIndentPage } from "@/features/stores/components/indent-pages";

export const Route = createFileRoute("/_app/warehouse/store-indents/new")({
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.indent.raise.warehouse"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <NewIndentPage
      area="warehouse"
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
